import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import _ from 'lodash' 
import { Link } from 'react-router-dom'
import { cardlistoutput } from '../actions'
import { withAuthenticator } from 'aws-amplify-react'

class CardList extends Component {
  componentDidMount(){ 
    const {params} = this.props.match
    //console.log("uuuuuu")
    //console.log(params.id1)
    //console.log(params.id2)
    //console.log("uuuuuu")
    this.props.cardlistoutput({set_name:params.id1})
  } 

  renderEvents(){
    const slice_num = 30
    const {params} = this.props.match
    console.log("qqqqqqq")
    console.log(params.id2 * slice_num)
    console.log("qqqqqqq")
    const slice_array = Array.prototype.slice.call(this.props.cardlistevent,params.id2 * slice_num,params.id2 * slice_num + slice_num)
    return _.map(slice_array,event =>
        <img src={`https://mtg.www.montamanet.com/cards/${event.multiverse_id}.png`}/>
    )
  }
  renderEvents2(){
    const slice_num = 30
    const {params} = this.props.match
    const repeat_num = Math.ceil(this.props.cardlistevent.length / slice_num)
    const items = [];
    for (let i = 0; i < repeat_num; i++) {
      items.push(
        <span> <Link className="header" to={`/CardList/${params.id1}/${i}`}>{i}</Link> </span>
      )
    }
    return (
      <div id="list">{items}</div>
    )
  }

  render() {
    return (
      <div>
        {this.renderEvents2()} 
        {this.renderEvents()} 
      </div>
      )
  }
}

const mapStateToProps = state => ({ cardlistevent: state.cardlistevent}) 
const mapDispatchToProps = ({ cardlistoutput })  
export default withAuthenticator(connect(mapStateToProps, mapDispatchToProps)(CardList))
